import React from 'react';

import { Placements } from '@videoblocks/storywind';

import SignUpForMakerPopover from '../../../../../../common/components/Popover/SignUpForMakerPopover';
import { StockItem } from '../../../../../../common/types/StockItemTypes';

export interface MakerButtonProps {
  stockItem: StockItem;
  makerButtonTelemetryAction?: () => void;
}

export const MakerButton = ({
  stockItem,
  makerButtonTelemetryAction,
}: MakerButtonProps) => {
  return (
    <SignUpForMakerPopover
      mediaType="video"
      className="text-white bg-gray-900 w-10 h-10 rounded-full p-3 hover:bg-opacity-90 cursor-pointer"
      iconClassName="fill-current w-4 h-4"
      stockItemId={stockItem.id}
      onClickAction={() => makerButtonTelemetryAction?.()}
      placement={Placements.Top}
    />
  );
};
